export default __webpack_public_path__ + "static/media/img20.4bb6f65f.jpg";